import React from "react";
import { FaEdit } from "react-icons/fa";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBadge,
  MDBIcon,
} from "mdb-react-ui-kit";
import Form from "react-bootstrap/Form";

import "../sso-management.css";
import "./UserEditModal.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import { DualPicklist } from "Projects/CC_cubi_clan_project/GlobalComponents/DualPicklist/DualPicklist";
import { validatePasswordStrength } from "Projects/SSO_single_sign_on_project/Utils/PasswordUtils";

export class UserEditModal extends React.Component {
  constructor(props) {
    super(props);

    let dataDefault = {
      IDUsuario: null,
      apodo: "",
      password: "",
      email: "",
      nombre: "",
      apellido: "",
      telefono: "",
      activo: 0,
      userImg: ""
    };

    this.state = {
      showUserEditModal: this.props.showUserEditModal,
      appsData: [],
      data: Object.assign(dataDefault, this.props.data),
      enabled: this.props.data.activo,
      selectedApp: "",
      appPermisoList: [],
      permisoListAvaiable: [],
      permisoListSelected: [],
      filaSeleccionadaAdd: null,
      filaSeleccionadaRemove: null,
      mapAppPermisosSelected: {},
      // Groups
      allGrupos: [],
      gruposAvailable: [],
      gruposSelected: [],
      allUserGrupos: [],
      filaGrupoAdd: null,
      filaGrupoRemove: null,
      showPassword: false,
      passwordError: "",
    };
  }

  componentDidMount() {
    this.getApps();
    this.loadGrupos();
    this.scrollModalToTop();
  }

  scrollModalToTop() {
    setTimeout(() => {
      const el = document.querySelector('.modal.show');
      if (el) el.scrollTop = 0;
    }, 150);
  }

  getApps() {
    this.props.onLoading(true);

    doFetch("SSO", "getAllAplicaciones", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ selectedApp: data.DATA[0].IDAplicacion });
        this.setState({ appsData: data.DATA });
        this.fillPermisos(data.DATA[0].IDAplicacion);
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  async fillPermisos(selectedApp) {
    let appPermisoList = await this.getAppPermisions(selectedApp);
    let userAppPermisos = await this.getUserAppPermisions(selectedApp);
    let groupPermisos = await this.getUserAppGroupPermissions(selectedApp);

    // Mark direct permissions
    userAppPermisos.forEach((p) => { p.origen = "directo"; });

    // Add group permissions that are not already direct
    groupPermisos.forEach((gp) => {
      if (!userAppPermisos.find((up) => up.value.IDPermiso === gp.value.IDPermiso)) {
        userAppPermisos.push(gp);
      }
    });

    let permisoListAvaiable = appPermisoList.filter(
      (appPer) =>
        !userAppPermisos.find(
          (userPer) => userPer.value.IDPermiso === appPer.value.IDPermiso
        )
    );

    appPermisoList.sort((a, b) => this.permisosCompare(a, b));
    userAppPermisos.sort((a, b) => this.permisosCompare(a, b));
    permisoListAvaiable.sort((a, b) => this.permisosCompare(a, b));

    let mapAppPermisosSelected = this.state.mapAppPermisosSelected;
    mapAppPermisosSelected[selectedApp] = userAppPermisos;

    this.setState({ appPermisoList: appPermisoList });
    this.setState({ permisoListAvaiable: permisoListAvaiable });
    this.setState({ permisoListSelected: userAppPermisos });
    this.setState({ mapAppPermisosSelected: mapAppPermisosSelected });
  }

  async getAppPermisions(selectedApp) {
    let permisosList = [];
    if (selectedApp) {
      this.props.onLoading(true);

      let requestOptions = {
        method: "GET",
      };

      let method = "getAppPermisions?IDAplicacion=" + selectedApp;

      await doFetch("SSO", method, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          permisosList = [];
          for (let dat of data.DATA) {
            permisosList.push({ label: dat.nombre, value: dat });
          }
        })
        .catch((error) => {
          console.error(
            "Error al obtener datos:",
            JSON.stringify(error, null, 2)
          );
        })
        .finally(() => {
          this.props.onLoading(false);
        });
    }
    return permisosList;
  }

  async getUserAppPermisions(selectedApp) {
    let permisosList = [];
    if (selectedApp) {
      if (
        !Object.keys(this.state.mapAppPermisosSelected).includes(selectedApp)
      ) {
        this.props.onLoading(true);

        let requestOptions = {
          method: "GET",
        };

        let method =
          "getUserAppPermisions?IDAplicacion=" +
          selectedApp +
          "&IDUsuario=" +
          this.state.data.IDUsuario;

        await doFetch("SSO", method, requestOptions)
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            permisosList = [];
            for (let dat of data.DATA) {
              permisosList.push({ label: dat.nombre, value: dat });
            }
          })
          .catch((error) => {
            console.error(
              "Error al obtener datos:",
              JSON.stringify(error, null, 2)
            );
          })
          .finally(() => {
            this.props.onLoading(false);
          });
      } else {
        permisosList = this.state.mapAppPermisosSelected[selectedApp];
      }
    }
    return permisosList;
  }

  async getUserAppGroupPermissions(selectedApp) {
    let permisosList = [];
    if (selectedApp && this.state.data.IDUsuario) {
      let requestOptions = { method: "GET" };
      let method =
        "getUserAppGroupPermissions?IDAplicacion=" +
        selectedApp +
        "&IDUsuario=" +
        this.state.data.IDUsuario;

      await doFetch("SSO", method, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          for (let dat of data.DATA) {
            permisosList.push({
              label: dat.nombre,
              value: dat,
              origen: "grupo",
              grupos: dat.grupos,
            });
          }
        })
        .catch((error) => {
          console.error("Error al obtener permisos de grupo:", JSON.stringify(error, null, 2));
        });
    }
    return permisosList;
  }

  closeModal() {
    this.props.onCloseModal();
  }

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "app":
        this.setState({ selectedApp: event.target.value }, () => {
          this.fillPermisos(event.target.value);
          this.loadGrupos();
        });
        break;
      case "enabled":
        data["activo"] = this.state.enabled ? 0 : 1;
        this.setState(data);
        this.setState({ enabled: !this.state.enabled });
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState(data);
        break;
    }
  }

  handleAddButtonClick(index, element) {
    this.setState({ filaSeleccionadaAdd: index });
  }

  handleRemoveButtonClick(index, element) {
    this.setState({ filaSeleccionadaRemove: index });
  }

  handleAddButtonDoubleClick(index, element) {
    if (index != null && element != null) {
      let permisoList = this.state.permisoListAvaiable;
      permisoList.splice(index, 1);

      let permisoListSelected = this.state.permisoListSelected;
      permisoListSelected.push(element);

      permisoListSelected.sort((a, b) => this.permisosCompare(a, b));

      let mapAppPermisosSelected = this.state.mapAppPermisosSelected;
      mapAppPermisosSelected[this.state.selectedApp] = permisoListSelected;

      this.setState({
        permisoListAvaiable: permisoList,
        filaSeleccionadaAdd: null,
      });
      this.setState({ permisoListSelected: permisoListSelected });
      this.setState({ mapAppPermisosSelected: mapAppPermisosSelected });
    }
  }

  handleRemoveButtonDoubleClick(index, element) {
    if (index != null && element != null && element.origen !== "grupo") {
      let permisoList = this.state.permisoListSelected;
      permisoList.splice(index, 1);

      let permisoListAvaiable = this.state.appPermisoList.filter(
        (appPer) =>
          !permisoList.find(
            (userPer) => userPer.value.IDPermiso === appPer.value.IDPermiso
          )
      );

      permisoListAvaiable.sort((a, b) => this.permisosCompare(a, b));

      let mapAppPermisosSelected = this.state.mapAppPermisosSelected;
      mapAppPermisosSelected[this.state.selectedApp] = permisoList;

      this.setState({
        permisoListSelected: permisoList,
        filaSeleccionadaRemove: null,
      });
      this.setState({ permisoListAvaiable: permisoListAvaiable });
      this.setState({ mapAppPermisosSelected: mapAppPermisosSelected });
    }
  }

  async loadGrupos() {
    this.props.onLoading(true);

    let allGrupos = [];
    let userGrupos = [];

    // Get groups filtered by selected app
    let gruposMethod = "getAllGrupos";
    if (this.state.selectedApp) {
      gruposMethod += "?IDAplicacion=" + this.state.selectedApp;
    }

    await doFetch("SSO", gruposMethod, null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          allGrupos = data.DATA.map((g) => ({
            label: g.nombre,
            value: g,
          }));
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      });

    // Get user's groups
    let method = "getUserGrupos?IDUsuario=" + this.state.data.IDUsuario;
    await doFetch("SSO", method, null)
      .then((response) => response.json())
      .then((data) => {
        if (data.DATA) {
          userGrupos = data.DATA.map((g) => ({
            label: g.nombre,
            value: { IDGrupo: g.IDGrupo, nombre: g.nombre, descripcion: g.descripcion },
          }));
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    let gruposAvailable = allGrupos.filter(
      (g) => !userGrupos.find((ug) => ug.value.IDGrupo === g.value.IDGrupo)
    );

    // Filter user groups to only show those from the selected app
    let gruposSelectedForApp = userGrupos.filter(
      (ug) => allGrupos.find((g) => g.value.IDGrupo === ug.value.IDGrupo)
    );

    this.setState({
      allGrupos: allGrupos,
      gruposAvailable: gruposAvailable,
      gruposSelected: gruposSelectedForApp,
      allUserGrupos: userGrupos,
    });
  }

  handleGrupoAddClick(index) {
    this.setState({ filaGrupoAdd: index });
  }

  handleGrupoRemoveClick(index) {
    this.setState({ filaGrupoRemove: index });
  }

  handleGrupoAddDoubleClick(index, element) {
    if (index != null && element != null) {
      let gruposAvailable = [...this.state.gruposAvailable];
      gruposAvailable.splice(index, 1);

      let gruposSelected = [...this.state.gruposSelected];
      gruposSelected.push(element);

      this.setState({
        gruposAvailable: gruposAvailable,
        gruposSelected: gruposSelected,
        filaGrupoAdd: null,
      });
    }
  }

  handleGrupoRemoveDoubleClick(index, element) {
    if (index != null && element != null) {
      let gruposSelected = [...this.state.gruposSelected];
      gruposSelected.splice(index, 1);

      let gruposAvailable = this.state.allGrupos.filter(
        (g) => !gruposSelected.find((sg) => sg.value.IDGrupo === g.value.IDGrupo)
      );

      this.setState({
        gruposAvailable: gruposAvailable,
        gruposSelected: gruposSelected,
        filaGrupoRemove: null,
      });
    }
  }

  async doSave(event) {
    event.preventDefault();

    if (this.state.data.password) {
      const passwordError = validatePasswordStrength(this.state.data.password);
      if (passwordError) {
        this.setState({ passwordError });
        return;
      }
    }

    if (this.state.data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.data.email)) {
      alert("El email no tiene un formato válido");
      return;
    }

    let res = await this.updateUser();
    res = res ? await this.updateUserAppPermissions() : res;
    res = res ? await this.updateUserGroups() : res;

    if (res) {
      this.props.onCloseModal();
    }
  }

  async updateUser() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.data),
    };

    this.props.onLoading(true);

    await doFetch("SSO", "updateUser", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async updateUserAppPermissions() {
    let result = false;

    this.props.onLoading(true);

    let permisoList = [];
    for (let [app, permisos] of Object.entries(
      this.state.mapAppPermisosSelected
    )) {
      let directPermisos = permisos.filter((p) => p.origen !== "grupo");
      if (directPermisos.length > 0) {
        for (let permiso of directPermisos) {
          permisoList.push({
            IDAplicacionFK: { IDAplicacion: app },
            IDUsuarioFK: { IDUsuario: this.state.data.IDUsuario },
            IDPermisoFK: { IDPermiso: permiso.value.IDPermiso },
          });
        }
      } else {
        permisoList.push({
          IDAplicacionFK: { IDAplicacion: app },
          IDUsuarioFK: { IDUsuario: this.state.data.IDUsuario },
        });
      }
    }

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(permisoList),
    };

    this.props.onLoading(true);

    await doFetch("SSO", "updateUserAppPermissions", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async updateUserGroups() {
    let result = false;

    this.props.onLoading(true);

    // Merge: groups selected for current app + groups from other apps (not visible)
    let currentAppGroupIds = new Set(
      this.state.allGrupos.map((g) => g.value.IDGrupo)
    );
    let otherAppGroups = (this.state.allUserGrupos || []).filter(
      (g) => !currentAppGroupIds.has(g.value.IDGrupo)
    );
    let allGroups = [...this.state.gruposSelected, ...otherAppGroups];

    let gruposList = allGroups.map((g) => ({
      IDGrupoFK: { IDGrupo: g.value.IDGrupo },
    }));

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(gruposList),
    };

    let method = "updateUserGrupos?IDUsuario=" + this.state.data.IDUsuario;

    await doFetch("SSO", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error("Error:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  permisosCompare(a, b) {
    if (a.value.nombre > b.value.nombre) {
      return 1;
    }
    if (a.value.nombre < b.value.nombre) {
      return -1;
    }
    return 0;
  }

  setShow(event) {
    if (this.state.showUserEditModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  handleImageChange(result) {
    if (result?.uuid) {
      let data = this.state.data;
      data.imageUuid = result.uuid;
      this.setState({ data });
    }
  }

  handleImageDelete = () => {
    let data = this.state.data;
    data.imageUuid = "";
    this.setState({ data });
  };

  render() {
    return (
      <>
        <MDBModal
          show={this.state.showUserEditModal}
          setShow={(event) => this.setShow(event)}
          tabIndex="-1"
        >
          <MDBModalDialog size="xl">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle style={{ fontSize: "1.05rem" }}>
                  <MDBIcon fas icon="user-edit" className="me-2" />
                  Editar usuario: {this.state.data.apodo}
                </MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.closeModal()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer className="sso-modal-form">
                  {/* ── Datos del usuario ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="id-card" className="me-2" />
                    Datos del usuario
                  </h6>
                  <MDBRow>
                    <MDBCol md="3">
                      <MfmImageUploader
                        uuid={this.state.data.imageUuid}
                        img={this.state.data.userImg}
                        appCode="SSO"
                        mediaType="image"
                        onUpload={(result) => this.handleImageChange(result)}
                        onDelete={this.handleImageDelete}
                      />
                    </MDBCol>
                    <MDBCol md="9">
                      <MDBRow>
                        <MDBCol md="8">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="apodo"
                            label="Nombre de usuario"
                            value={this.state.data.apodo}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="4" className="d-flex align-items-center">
                          <MDBSwitch
                            id="enabled"
                            label="Activo"
                            checked={this.state.enabled}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type={this.state.showPassword ? "text" : "password"}
                            id="password"
                            label="Contraseña"
                            value={this.state.data.password}
                            onChange={(event) => {
                              this.handleChange(event);
                              this.setState({ passwordError: validatePasswordStrength(event.target.value) });
                            }}
                          />
                          {this.state.passwordError && (
                            <p className="text-danger mb-2" style={{ fontSize: "0.78rem" }}>{this.state.passwordError}</p>
                          )}
                        </MDBCol>
                        <MDBCol md="6" className="d-flex align-items-start pt-1">
                          <MDBBtn
                            type="button"
                            color="link"
                            size="sm"
                            className="p-0 text-decoration-none"
                            onClick={() => this.setState(prev => ({ showPassword: !prev.showPassword }))}
                          >
                            <MDBIcon fas icon={this.state.showPassword ? "eye-slash" : "eye"} className="me-1" />
                            {this.state.showPassword ? "Ocultar" : "Mostrar"}
                          </MDBBtn>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="email"
                            label="Email"
                            value={this.state.data.email}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="telefono"
                            label="Teléfono"
                            value={this.state.data.telefono}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="nombre"
                            label="Nombre"
                            value={this.state.data.nombre}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                        <MDBCol md="6">
                          <MDBInput
                            className="mb-3"
                            type="text"
                            id="apellido"
                            label="Apellidos"
                            value={this.state.data.apellido}
                            onChange={(event) => this.handleChange(event)}
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                  {/* ── Filtro por aplicación (afecta a Grupos y Permisos) ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="filter" className="me-2" />
                    Aplicación
                  </h6>
                  <MDBRow className="mb-3">
                    <MDBCol md="5">
                      <Form.Select
                        size="sm"
                        id="app"
                        value={this.state.selectedApp}
                        onChange={(event) => this.handleChange(event)}
                      >
                        {this.state.appsData.map((element, index) => (
                          <option key={index} value={element.IDAplicacion}>
                            {element.nombre + " — " + element.titulo}
                          </option>
                        ))}
                      </Form.Select>
                    </MDBCol>
                  </MDBRow>

                  {/* ── Grupos ── */}
                  <h6 className="sso-section-title">
                    <MDBIcon fas icon="users" className="me-2" />
                    Grupos
                  </h6>
                  <DualPicklist
                    available={this.state.gruposAvailable}
                    selected={this.state.gruposSelected}
                    titleLeft="Disponibles"
                    titleRight="Asignados"
                    height="200px"
                    onAdd={(item) => this.handleGrupoAddDoubleClick(
                      this.state.gruposAvailable.indexOf(item), item
                    )}
                    onRemove={(item) => this.handleGrupoRemoveDoubleClick(
                      this.state.gruposSelected.indexOf(item), item
                    )}
                  />

                  {/* ── Permisos específicos ── */}
                  <h6 className="sso-section-title mt-3">
                    <MDBIcon fas icon="key" className="me-2" />
                    Permisos específicos
                  </h6>
                  <DualPicklist
                    available={this.state.permisoListAvaiable}
                    selected={this.state.permisoListSelected}
                    titleLeft="Disponibles"
                    titleRight="Asignados"
                    height="220px"
                    onAdd={(item) => this.handleAddButtonDoubleClick(
                      this.state.permisoListAvaiable.indexOf(item), item
                    )}
                    onRemove={(item) => this.handleRemoveButtonDoubleClick(
                      this.state.permisoListSelected.indexOf(item), item
                    )}
                    isItemLocked={(item) => item.origen === "grupo"}
                    renderLockInfo={(item) => (
                      <MDBBadge color="light" pill className="text-muted" style={{ fontSize: "0.65rem" }}>
                        <MDBIcon fas icon="users" className="me-1" />
                        grupo
                      </MDBBadge>
                    )}
                  />

                  <div className="sso-modal-save-bar">
                    <MDBBtn onClick={(event) => this.doSave(event)}>
                      <MDBIcon fas icon="save" className="me-2" />
                      Guardar
                    </MDBBtn>
                  </div>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
